import { JobTitleSpecification } from './types';

export enum ErrorType {
  MissingTrackingPriority = 'MissingTrackingPriority',
  MissingCategory = 'MissingCategory',
  MismatchingCategory = 'MismatchingCategory',
  InvalidAnswer = 'InvalidAnswer',
  UnknownPriority = 'UnknownPriority',
}

export class PrioritizationError extends Error {
  constructor(type: ErrorType, jobTitleSpec?: JobTitleSpecification, message?: string) {
    super([type, 'error while prioritizing:', JSON.stringify(jobTitleSpec), message ?? ''].join(' '));
  }
}
